import React from 'react';

import { CurrencyFormat } from '../../../utils';
import usePaymentOptions from '../../hooks/usePaymentOptions';

const VersionPriceAndBonus = ({ model, version }) => {
    const { isMAF, isKinto } = usePaymentOptions();

    let price = version.price;
    let greenTax = version.green_tax

    // Verificar si tiene algún tipo de bonificación disponible según la opción de pago
    // Kinto: No aplican bonos
    // Contado: Solo bono marca
    // MAF: Bono marca + bono financiamiento + plan renueve (si aplica)
    const hasBonus = !isKinto && (
        version.brand_bonus || 
        (version.financing_bonus && isMAF) || 
        (version.smart_buy_bonus && isMAF)
    );

    return (
        <div className="details">
            <h1>{model.name} {version.name}</h1>
            <div className="version-price">
                <p>
                    {CurrencyFormat(price)} <sup>(&lowast;)</sup>
                    <span><small>+I.V. {CurrencyFormat(greenTax)}</small></span>
                </p>               
                <small>* Precio aplica para Régimen General y no para zona Franca</small>
            </div>
            {version.iva_warning ? <p className="version_warning">Precio incluye IVA</p> : null}
            {version.stock_warning ? <p className="version_warning">Consultar disponibilidad</p> : null}
            {hasBonus &&
                <div className="bonus-container">
                    <div className="bonus-image">
                        <img src={`${window._env_.STATIC_HOST}/static/website/images/icons/bonus.svg`} />
                    </div>
                    <div>
                        <p>El precio reflejado incluye</p>
                        <ul>
                            {version.brand_bonus && !isKinto && <li>Bono <strong>marca</strong> de {CurrencyFormat(version.brand_bonus)}.</li>}
                            {version.financing_bonus && isMAF && <li>Bono <strong>financiamiento MAF</strong> de {CurrencyFormat(version.financing_bonus)}.</li>}
                            {version.smart_buy_bonus && isMAF && <li>Bono <strong>financiamiento Plan Renueve</strong> de {CurrencyFormat(version.smart_buy_bonus)}.</li>}
                        </ul>
                    </div>

                </div>
            }
            <a className="btn outline-black payment-options-button" href="#payment-options">Simula tu financiamiento</a>
        </div>
    );
}

export default VersionPriceAndBonus;